(() => {
  const selector = '[data-nv-table-drag]';

  function bind(track) {
    if (track.dataset.nvTableDragReady === 'true') return;
    track.dataset.nvTableDragReady = 'true';
    let gesture = null;

    const start = (id, x, y, touchInput) => {
      if (track.scrollWidth <= track.clientWidth + 1) return;
      gesture = { id, x, y, left: track.scrollLeft, axis: '', touchInput };
    };

    const move = (id, x, y, event) => {
      if (!gesture || gesture.id !== id) return;
      const dx = x - gesture.x;
      const dy = y - gesture.y;
      if (!gesture.axis) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 6) return;
        if (Math.abs(dy) > Math.abs(dx)) {
          gesture = null;
          return;
        }
        gesture.axis = 'x';
        track.classList.add('is-dragging');
      }
      if (event.cancelable !== false) event.preventDefault();
      track.scrollLeft = gesture.left - dx;
    };

    const end = (id) => {
      if (!gesture || (id != null && gesture.id !== id)) return;
      gesture = null;
      track.classList.remove('is-dragging');
    };

    track.addEventListener('touchstart', (event) => {
      if (event.touches.length !== 1) { end(); return; }
      const touch = event.touches[0];
      start(touch.identifier, touch.clientX, touch.clientY, true);
    }, { passive: true });
    track.addEventListener('touchmove', (event) => {
      if (!gesture?.touchInput || event.touches.length !== 1) return;
      const touch = event.touches[0];
      move(touch.identifier, touch.clientX, touch.clientY, event);
    }, { passive: false });
    track.addEventListener('touchend', (event) => end(event.changedTouches[0]?.identifier), { passive: true });
    track.addEventListener('touchcancel', () => end(), { passive: true });

    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch' && 'ontouchstart' in window) return;
      if (event.isPrimary === false || (event.pointerType === 'mouse' && event.button !== 0)) return;
      start(event.pointerId, event.clientX, event.clientY, false);
    }, { passive: true });
    window.addEventListener('pointermove', (event) => {
      if (!gesture || gesture.touchInput || gesture.id !== event.pointerId) return;
      move(event.pointerId, event.clientX, event.clientY, event);
    }, { passive: false });
    window.addEventListener('pointerup', (event) => end(event.pointerId), { passive: true });
    window.addEventListener('pointercancel', (event) => end(event.pointerId), { passive: true });
    window.addEventListener('blur', () => end());
    track.addEventListener('dragstart', (event) => event.preventDefault());
  }

  const init = (root = document) => root.querySelectorAll(selector).forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
